var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.484.125a1 1 0 0 1 .502 1.04L11.181 6H14a1 1 0 0 1 .707 1.708l-8 8a1 1 0 0 1-1.693-.873L5.819 10H2a1 1 0 0 1-.664-1.75l9-7.998a1 1 0 0 1 1.148-.128M4.632 7.999H7a1 1 0 0 1 .986 1.166l-.486 2.92 4.085-4.084H10a1 1 0 0 1-.986-1.166l.534-3.206z",
    clipRule: "evenodd"
  })));
};
export default SvgFlash;